import Vue from 'vue';
import App from './App.vue'
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate';
import vueTopprogress from 'vue-top-progress'
import { i18n } from "./services/i18n";
import commonPlugin from './plugins/commonPlugin';
import VueGeolocation from 'vue-browser-geolocation';
import { Scroll } from 'vuetify/lib/directives'
import VueQrcodeReader from "vue-qrcode-reader";
import JsonExcel from "vue-json-excel";
import './main.css';
import './registerServiceWorker';


Vue.config.productionTip = false;
Vue.use(VueQrcodeReader);
Vue.use(Vuelidate);
Vue.use(vueTopprogress)
Vue.use(commonPlugin);
Vue.use(VueGeolocation);
Vue.directive("scroll",Scroll);
Vue.component("downloadExcel", JsonExcel);
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');


